import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class OrderdateService {
  private initorderdate = new BehaviorSubject('');
  orderdate = this.initorderdate.asObservable();
  constructor() { }

  changeOrderDate(date: string) {
    this.initorderdate.next(date);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/orderdate.service.ts